import { CampanhaFilter } from './campanha-filter';

export class CampanhaFilterStorage {
    filter: CampanhaFilter;
    filterValues: Map<string, any>;

    constructor(filter: CampanhaFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
